import { createSelector } from 'reselect';

export const getStoreDetails = createSelector(
  (state) => state.thdStoreInfo,
  (thdStoreInfo) => thdStoreInfo,
);
